import React from "react";
import { motion } from "framer-motion"; // Importing framer-motion for scroll animations
import "../../assets/styles/brands.css";
import Brands from "../../assets/images/brands.svg";
import BrandCards from "../../assets/images/brandCards.svg";

const Brand = ({ title, subtitle, stats }) => {
  return (
    <div className="brands-section">
      <div className="brands-background"></div>
      {/* Animated Header Section */}
      <header className="text-center py-5">
        <motion.h1
          className="title"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }} // Trigger animation when 30% is in view
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          BRANDS
        </motion.h1>
        <br />

        {/* Container for Paragraph and Image with Same Width */}
        <div
          className="content-container"
          style={{ width: "80%", margin: "0 auto" }}
        >
          {/* Animated Paragraph */}
          <motion.p
            className="newsubtitle"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
          >
            Leading Brands, Limitless Possibilities.
            </motion.p>
          <motion.p
            className="subtitle"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
          >
            As a premier provider of
            tech-enabled solutions, commceed combines industry-leading
            expertise with seamless, end-to-end support. From design to
            deployment, our vast portfolio of top-tier brands ensures we offer
            the best products and services to suit your needs. New brands are
            continuously being added to our selection. Check back for the latest
            updates.
          </motion.p>

          {/* Animated Image */}
          <motion.img
            src={BrandCards}
            alt="Brand Cards"
            className="brand-cards-img"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1.5, ease: "easeInOut", delay: 0.4 }}
            style={{
              width: "100%", // Makes the image take the full width of the container
              height: "auto", // Maintains the aspect ratio
            }}
          />
        </div>
      </header>
    </div>
  );
};

export default Brand;
